import { Chip } from "@mui/material";
import { riskLevel, scheduleStatus } from "../constants/labels";
import { ossChipSx } from "./common/ossChipStyles";

export const OssStatusChip = ({ type = "schedule", value, size = "small" }) => {
  const source = type === "risk" ? riskLevel : scheduleStatus;
  const meta = source[value] || { label: value || "-", tone: "#64748b", bg: "#f8fafc" };
  return (
    <Chip
      size={size}
      label={meta.label}
      variant="outlined"
      sx={ossChipSx({ tone: meta.tone, bg: meta.bg, size })}
    />
  );
};
